import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type, decimal_type, int32_type, record_type, lambda_type, unit_type, option_type, class_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Symbol$, Symbol$_$reflection } from "../Shopfoo.Domain.Types/Common.js";
import { join, interpolate, toText } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { createElement } from "react";
import React from "react";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { map, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { isEmpty, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";

export class ActionProps extends Record {
    constructor(Key, Text$, Icon, OnClick) {
        super();
        this.Key = Key;
        this.Text = Text$;
        this.Icon = Icon;
        this.OnClick = OnClick;
    }
}

export function ActionProps_$reflection() {
    return record_type("Shopfoo.Client.Components.Actions.ActionProps", [], ActionProps, () => [["Key", string_type], ["Text", string_type], ["Icon", option_type(class_type("Fable.React.ReactElement", undefined))], ["OnClick", lambda_type(unit_type, unit_type)]]);
}

export function ActionProps_withIcon(key, icon, text, onClick) {
    return new ActionProps(key, text, icon, onClick);
}

export class Value extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Natural", "Money"];
    }
}

export function Value_$reflection() {
    return union_type("Shopfoo.Client.Components.Actions.Value", [], Value, () => [[["value", int32_type]], [["value", option_type(decimal_type)], ["currency", option_type(Symbol$_$reflection())]]]);
}

export function Value_get_OfMoney() {
    return (_arg) => ((_arg.tag === 1) ? (new Value(1, [_arg.fields[0], new Symbol$(1, ["€"])])) : (new Value(1, [_arg.fields[0], new Symbol$(0, ["$"])])));
}

export function Value_get_OfMoneyOptional() {
    return (_arg) => {
        if (_arg == null) {
            return new Value(1, [undefined, undefined]);
        }
        else {
            const money = _arg;
            return Value_get_OfMoney()(money);
        }
    };
}

export function Value__get_Symbol(this$) {
    if (this$.tag === 1) {
        return this$.fields[1];
    }
    else {
        return undefined;
    }
}

export function Value__get_Text(this$) {
    if (this$.tag === 1) {
        if (this$.fields[0] != null) {
            const f = this$.fields[0];
            return toText(interpolate("%0.2f%P()", [f]));
        }
        else {
            return "";
        }
    }
    else {
        return `${this$.fields[0]}`;
    }
}

export function ActionsDropdown(actionsDropdownInputProps) {
    let elems_6;
    const actions = actionsDropdownInputProps.actions;
    const value = actionsDropdownInputProps.value;
    const access = actionsDropdownInputProps.access;
    const css = actionsDropdownInputProps.css;
    const key = actionsDropdownInputProps.$key;
    return createElement("div", createObj(ofArray([["key", `${key}-div`], ["className", `flex items-center w-full ${css}`], (elems_6 = toList(delay(() => {
        let elems_2;
        return append(singleton(createElement("label", createObj(Helpers_combineClasses("input", ofArray([["key", `${key}-label-input`], ["className", "bg-base-300 flex-1"], (elems_2 = toList(delay(() => {
            let matchValue_1, symbol;
            return append((matchValue_1 = Value__get_Symbol(value), (matchValue_1 != null) ? ((matchValue_1.tag === 0) ? ((symbol = matchValue_1.fields[0], singleton(createElement("span", createObj(Helpers_combineClasses("label", ofArray([["key", `${key}-label-symbol`], ["children", symbol]]))))))) : (empty())) : (empty())), delay(() => append(singleton(createElement("input", {
                key: `${key}-input`,
                className: "flex-1",
                value: Value__get_Text(value),
                onChange: (ev) => {
                    ev.target.checked;
                },
                readOnly: true,
                type: "text",
            })), delay(() => {
                const matchValue_2 = Value__get_Symbol(value);
                let matchResult, symbol_1;
                if (matchValue_2 != null) {
                    if (matchValue_2.tag === 1) {
                        matchResult = 0;
                        symbol_1 = matchValue_2.fields[0];
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return singleton(createElement("span", createObj(Helpers_combineClasses("label", ofArray([["key", `${key}-label-symbol`], ["children", symbol_1]])))));
                    default: {
                        return empty();
                    }
                }
            }))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))))), delay(() => {
            let elems_5, elems_4, elems_3;
            let matchResult_1;
            if (isEmpty(actions)) {
                matchResult_1 = 0;
            }
            else if (access != null) {
                if (access.tag === 1) {
                    matchResult_1 = 1;
                }
                else {
                    matchResult_1 = 0;
                }
            }
            else {
                matchResult_1 = 0;
            }
            switch (matchResult_1) {
                case 0: {
                    return empty();
                }
                default:
                    return singleton(createElement("div", createObj(Helpers_combineClasses("dropdown", ofArray([["className", "dropdown-hover"], ["className", "dropdown-end"], ["key", `${key}-dropdown`], ["className", "ml-2"], (elems_5 = [createElement("button", createObj(Helpers_combineClasses("btn", ofArray([["className", "btn-primary"], ["className", "btn-outline"], ["key", `${key}-dropdown-button`], ["className", "p-3"], ["children", "⏷"]])))), createElement("ul", createObj(Helpers_combineClasses("dropdown-content", ofArray([["key", `${key}-dropdown-content`], ["className", "p-2 shadow menu bg-base-100 rounded-box"], ["tabIndex", 0], (elems_4 = [createElement("ul", createObj(ofArray([["key", `${key}-dropdown-list`], (elems_3 = toList(delay(() => map((action_1) => {
                        let elems_1, elems;
                        const action = action_1;
                        return createElement("li", createObj(ofArray([["key", `${key}-action--${action.Key}`], (elems_1 = [createElement("a", createObj(ofArray([["key", `${key}-action--${action.Key}-link`], ["className", "flex items-center justify-start"], ["onClick", (_arg) => {
                            action.OnClick();
                        }], (elems = toList(delay(() => {
                            let matchValue;
                            return append((matchValue = action.Icon, (matchValue == null) ? (empty()) : singleton(matchValue)), delay(() => singleton(createElement("span", {
                                key: `${key}-action--${action.Key}-text`,
                                className: join(" ", toList(delay(() => append(singleton("whitespace-nowrap"), delay(() => ((action.Icon != null) ? singleton("ml-1") : empty())))))),
                                children: action.Text,
                            }))));
                        })), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
                    }, actions))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

